import { analyticsConstants } from "../constants/analytics.constants";

export function analytics(state = {}, action) {
  switch (action.type) {
    case analyticsConstants.GET_DASHBOARD_STATS_REQUEST:
      return {
        ...state,
        loadingDashboardStats: true,
      };
    case analyticsConstants.GET_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        loadingDashboardStats: false,
        dashboardStats: action.payload,
      };
    case analyticsConstants.GET_DASHBOARD_STATS_FAILURE:
      return {
        ...state,
        loadingDashboardStats: false,
      };
    case analyticsConstants.GET_EXECUTION_STATS_REQUEST:
      return {
        ...state,
        loadingExecutionStats: true,
        requestExecutionStats: action.payload,
      };
    case analyticsConstants.GET_EXECUTION_STATS_SUCCESS:
      return {
        ...state,
        loadingExecutionStats: false,
        executionStats: action.payload,
      };
    case analyticsConstants.GET_EXECUTION_STATS_FAILURE:
      return {
        ...state,
        loadingExecutionStats: false,
      };
    case analyticsConstants.GET_EXECUTION_TRENDS_REQUEST:
      return {
        ...state,
        loadingExecutionTrends: true,
        requestExecutionTrends: action.payload,
      };
    case analyticsConstants.GET_EXECUTION_TRENDS_SUCCESS:
      return {
        ...state,
        loadingExecutionTrends: false,
        executionTrends: action.payload,
      };
    case analyticsConstants.GET_EXECUTION_TRENDS_FAILURE:
      return {
        ...state,
        loadingExecutionTrends: false,
      };
    case analyticsConstants.GET_API_USAGE_REQUEST:
      return {
        ...state,
        loadingApiUsage: true,
        requestApiUsage: action.payload,
      };
    case analyticsConstants.GET_API_USAGE_SUCCESS:
      return {
        ...state,
        loadingApiUsage: false,
        apiUsage: action.payload,
      };
    case analyticsConstants.GET_API_USAGE_FAILURE:
      return {
        ...state,
        loadingApiUsage: false,
      };
    case analyticsConstants.GET_API_FAILURES_REQUEST:
      return {
        ...state,
        loadingApiFailures: true,
        requestApiFailures: action.payload,
      };
    case analyticsConstants.GET_API_FAILURES_SUCCESS:
      return {
        ...state,
        loadingApiFailures: false,
        apiFailures: action.payload,
      };
    case analyticsConstants.GET_API_FAILURES_FAILURE:
      return {
        ...state,
        loadingApiFailures: false,
      };
    case analyticsConstants.GET_API_RECORDS_REQUEST:
      return {
        ...state,
        loadingApiRecords: true,
        requestApiRecords: action.payload,
      };
    case analyticsConstants.GET_API_RECORDS_SUCCESS:
      return {
        ...state,
        loadingApiRecords: false,
        apiRecords: action.payload,
      };
    case analyticsConstants.GET_API_RECORDS_FAILURE:
      return {
        ...state,
        loadingApiRecords: false,
      };
    case analyticsConstants.GET_RUNBOOK_OVERVIEW_REQUEST:
      return {
        ...state,
        loadingRunbookOverview: true,
        requestRunbookOverview: action.payload,
      };
    case analyticsConstants.GET_RUNBOOK_OVERVIEW_SUCCESS:
      return {
        ...state,
        loadingRunbookOverview: false,
        runbookOverview: action.payload,
      };
    case analyticsConstants.GET_RUNBOOK_OVERVIEW_FAILURE:
      return {
        ...state,
        loadingRunbookOverview: false,
      };
    case analyticsConstants.GET_RUNBOOK_EXECUTIONS_REQUEST:
      return {
        ...state,
        // First page shows the main loader; subsequent pages show "load more".
        loadingRunbookExecutions: action.append ? state.loadingRunbookExecutions : true,
        loadingMoreRunbookExecutions: action.append === true,
        requestRunbookExecutions: action.payload,
      };
    case analyticsConstants.GET_RUNBOOK_EXECUTIONS_SUCCESS: {
      const existing = action.append ? state.runbookExecutions || [] : [];
      return {
        ...state,
        loadingRunbookExecutions: false,
        loadingMoreRunbookExecutions: false,
        runbookExecutions: [...existing, ...(action.items || [])],
        runbookExecutionsNextCursor: action.nextCursor,
        runbookExecutionsHasMore: action.hasMore,
      };
    }
    case analyticsConstants.GET_RUNBOOK_EXECUTIONS_FAILURE:
      return {
        ...state,
        loadingRunbookExecutions: false,
        loadingMoreRunbookExecutions: false,
      };
    case analyticsConstants.GET_EXECUTION_DETAIL_REQUEST:
      return {
        ...state,
        loadingExecutionDetail: true,
        requestExecutionDetail: action.payload,
      };
    case analyticsConstants.GET_EXECUTION_DETAIL_SUCCESS:
      return {
        ...state,
        loadingExecutionDetail: false,
        executionDetail: action.payload,
      };
    case analyticsConstants.GET_EXECUTION_DETAIL_FAILURE:
      return {
        ...state,
        loadingExecutionDetail: false,
      };
    default:
      return state;
  }
}
